import React, { useEffect } from 'react';
import Home from './home';
import Project from './project';
import ProjectCategory from './project/ProjectCategory';
import ServiceCategory from './service/ServiceCategory';
import Service from './service';
import ServiceDetail from './details/ServiceDetail';
import ProjectDetail from './details/ProjectDetail';
import Login from './user/Login';
import Signup from './user/Signup';
import Profile from './profile';
import UserProfile from './user/UserProfile';
import NewProject from './profile/NewProject';
import NewService from './profile/NewService';
import { Switch, Route } from 'react-router-dom';
import styled from 'styled-components';
import ProjectContextProvider from '../../contexts/ProjectsContext';
import ServiceContextProvider from '../../contexts/ServiceContext';
import AOS from 'aos';
import 'aos/dist/aos.css';


const MainStyled = styled.main`
	min-height: 80vh;
`;

const Main = () => {
	useEffect(() => {
	  AOS.init({
	    duration : 1000
	  });
	  AOS.refresh();
	}, []);

	return(
		<ProjectContextProvider><ServiceContextProvider>
			<MainStyled>
				<Switch>
					<Route exact path='/' component={Home} />
					<Route path='/layanan/:serviceId' component={ServiceDetail} />
					<Route path='/proyek/:projectId' component={ProjectDetail} />
					<Route path='/proyek-kategori/:categoryId' component={ProjectCategory} />
					<Route path='/layanan-kategori/:categoryId' component={ServiceCategory} />
					<Route path='/profil/:userId' component={UserProfile} />
          <Route path='/beranda' component={Home} />
          <Route path='/proyek' component={Project} />
          <Route path='/layanan' component={Service} />
          <Route path='/login' component={Login} />
          <Route path='/signup' component={Signup} />
          <Route path='/me' component={Profile} />
          <Route path='/newproject' component={NewProject} />
          <Route path='/newservice' component={NewService} />
				</Switch>
			</MainStyled>
		</ServiceContextProvider></ProjectContextProvider>
	);
}

export default Main;